"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogicalOperator = isLogicalOperator;
exports.isAndOperator = isAndOperator;
exports.isOrOperator = isOrOperator;
exports.isNotOperator = isNotOperator;
exports.and = and;
exports.or = or;
exports.not = not;
function isLogicalOperator(filter) {
    return isAndOperator(filter) || isOrOperator(filter) || isNotOperator(filter);
}
function isAndOperator(filter) {
    return (Object.keys(filter).length === 1 &&
        '$and' in filter &&
        Array.isArray(filter.$and));
}
function isOrOperator(filter) {
    return (Object.keys(filter).length === 1 &&
        '$or' in filter &&
        Array.isArray(filter.$or));
}
function isNotOperator(filter) {
    return (Object.keys(filter).length === 1 &&
        '$not' in filter &&
        typeof filter.$not === 'object');
}
function and(a, b) {
    if (typeof a === 'undefined' || Object.keys(a).length === 0) {
        return b;
    }
    else if (typeof b === 'undefined' || Object.keys(b).length === 0) {
        return a;
    }
    else {
        return {
            $and: [
                ...(isAndOperator(a) ? a.$and : [a]),
                ...(isAndOperator(b) ? b.$and : [b]),
            ],
        };
    }
}
function or(a, b) {
    if (typeof a === 'undefined' || Object.keys(a).length === 0) {
        return b;
    }
    else if (typeof b === 'undefined' || Object.keys(b).length === 0) {
        return a;
    }
    else {
        return {
            $or: [
                ...(isOrOperator(a) ? a.$or : [a]),
                ...(isOrOperator(b) ? b.$or : [b]),
            ],
        };
    }
}
function not(a) {
    if (typeof a === 'undefined' || Object.keys(a).length === 0) {
        return undefined;
    }
    else if (isNotOperator(a)) {
        return a.$not;
    }
    else {
        return { $not: a };
    }
}
